const L = {
  name: "Diamond",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.6178 2H4.38176L0.825195 9.11314L11.9998 23.6401L23.1744 9.11314L19.6178 2ZM3.61783 8L5.61783 4H8.61231L7.27897 8H3.61783ZM4.03066 10H7.26115L9.41482 16.9994L4.03066 10ZM9.35369 10H14.6458L11.9997 18.5996L9.35369 10ZM16.7383 10H19.9689L14.5845 16.9997L16.7383 10ZM20.3818 8H16.7205L15.3871 4H18.3818L20.3818 8ZM14.6123 8H9.38716L10.7205 4H13.279L14.6123 8Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as Diamond
};
